import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsPublicListRequest() {
  const {
    host,
    URIs: { pmsPublicList },
  } = apiConfig;

  const uri = `${host}${pmsPublicList}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
